import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import Seo from "../seo/Seo";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Container size="sm" py="xl">
      <Seo
        title="404 | Page Not Found | SubjectBuddy"
        description="The page you requested could not be found."
        path="/404"
        noIndex
      />
      <Stack gap="md" align="flex-start">
        <Title order={1}>Page not found</Title>
        <Text c="dimmed">
          The page you tried to open does not exist or may have moved.
        </Text>
        <Button onClick={() => navigate("/")}>Back to home</Button>
      </Stack>
    </Container>
  );
}

export default NotFound;
